import { properCase } from 'Helpers/Formats';

export const isPaidByCreditCard = invoice => invoice.attr('cardBrand') || invoice.attr('lastFourDigits');

export const wasFailedPayment = invoice => !!invoice.attr('errorCode');

export const creditCardBrand = invoice => properCase(invoice.attr('cardBrand') || '');

export const shortenedCreditCardBrand = invoice => {
  let brand = creditCardBrand(invoice);
  brand = brand.toLowerCase();
  if (brand === 'mastercard') {
    return brand.replace('mastercard', 'MC');
  }
  return properCase(brand);
};
